import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-24e53738"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "animate modal modal-pdf"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"color":"white"} }, "Estamos generando tus apuntes.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"color":"white"} }, "No cierres esta ventana hasta que se inicie la descarga.", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"margin-bottom":"20px"} }, "Imprimir apuntes en PDF", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_8 = { class: "search-form" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Tienes apuntes tomados en los siguientes cursos:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "container-items"
}
const _hoisted_14 = { class: "list" }
const _hoisted_15 = ["onClick"]

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { ref, Ref, onMounted } from 'vue'
import DiplomaService from '@/services/DiplomaService'
import { useAuth } from '@/store/useAuth'
import router from '@/router'
import SharedService from '@/services/SharedService'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyNotesPdfView',
  setup(__props) {

const loading = ref(true)
const sharedService = new SharedService()
const courses = ref()
const filteredDiplomas = ref()
const store = useAuth()
const search: Ref<string> = ref('')
const sending = ref(false)

const handleGenerate = async (courseID: number) => {
    if (!store.token) {
        return;
    }

    sending.value = true;

    try {
        const pdf: Blob | undefined = await sharedService.printNotes(store.token, courseID);

        if (!pdf) {
            console.error("Failed to generate the notes PDF.");
            sending.value = false;
            return;
        }

        // Verificar si msSaveOrOpenBlob está disponible
        const navigatorAny = window.navigator as any;
        if (navigatorAny.msSaveOrOpenBlob) {
            navigatorAny.msSaveOrOpenBlob(pdf);
        } else {
            const objUrl = window.URL.createObjectURL(pdf);
            const link = document.createElement("a");
            link.href = objUrl;
            link.download = "apuntes";
            link.click();
            setTimeout(() => {
                window.URL.revokeObjectURL(objUrl);
            }, 250);
        }
    } catch (error) {
        console.error("An error occurred while generating the PDF:", error);
    } finally {
        sending.value = false;
    }
};
onMounted(async () => {
    if (!store.token) {
        router.push({ name: 'home' })
        return
    }
    loading.value = true
    courses.value = await sharedService.getAllCoursesWithNotes(store.token)
    filteredDiplomas.value = courses.value
    loading.value = false
})

const handleSearch = () => {
    loading.value = true
    filteredDiplomas.value = courses.value.filter((item: any)=> item.name.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (sending.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "md-downloading",
              scale: "5",
              animation: "flash",
              fill: "#fff"
            }),
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (sending.value = false)),
              style: {"color":"white"}
            }, "Cancelar")
          ]))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_RouterLink, {
              to: {name: 'my-notes'},
              class: "print"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Volver a mis apuntes")
              ]),
              _: 1
            }),
            _hoisted_7,
            _createElementVNode("form", _hoisted_8, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                placeholder: "Escribe aquí para filtrar.",
                onKeyup: handleSearch
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ]),
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_v_icon, {
                    name: "ri-loader-2-fill",
                    animation: "spin",
                    class: "icon"
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDiplomas.value, (course) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: course.id,
                      class: "animate card"
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("h4", {
                          class: "clickable",
                          onClick: ($event: any) => (handleGenerate(course.id))
                        }, _toDisplayString(course.name.substring(0, 40)), 9, _hoisted_15)
                      ])
                    ]))
                  }), 128))
                ]))
          ]))
    ]),
    _: 1
  }))
}
}

})